import { render, staticRenderFns } from "./PaginationList.vue?vue&type=template&id=273598f8"
import script from "./PaginationList.vue?vue&type=script&lang=js"
export * from "./PaginationList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports